import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { RegularSection, ColorTitle } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'
import { resolveHref } from '@/utilites/resolveHref'
import Link from 'next/link'

interface Card {
    image?: string | Record<string, unknown>
    title?: string
    description?: string
    link?: string
}

interface Content {
    title?: string
    subtitle?: string
    cards?: Card[]
}

interface S3_about_6Props {
    content?: Content
    blockName?:string
}

const Index = (props: S3_about_6Props) => {
    const { content = {} } = props
    const { title, subtitle, cards = [] } = content
    return (
        <RegularSection aria-label='S3_about_6' >
            <ColorTitle title={title} colorFrom={0} textAlign='start' width='100%'/>

            <Typography
                variant='subtitle1'
                sx={{ textAlign: 'start', width: '100%' }}
            >
                {subtitle}
            </Typography>

            <Grid
                container
                spacing={4}
                sx={{ width: '100%' }}
            >
                {cards.map((card, index) => {
                    const { src } = getImageData(card.image)
                    return (
                    <Grid key={'blog-card-' + index} size={{ xs: 12, md: 4 }}>
                        <Link href={resolveHref(card?.link)} style={{ textDecoration: 'none', display: 'block', width: '100%' }}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'flex-end',
                                    gap: 2,
                                    backgroundImage: `url(${src})`,
                                    backgroundSize: 'cover',
                                    borderRadius: 5,
                                    minHeight: { xs: 300, md: 450 },
                                    textDecoration: 'none',
                                    p: 4,
                                }}
                            >
                                <Typography
                                    variant='h3'
                                    sx={{ textAlign: 'start', width: '100%', color: 'white' }}
                                >
                                    {card.title}
                                </Typography>
                                <Typography
                                    variant='body1'
                                    sx={{ textAlign: 'start', width: '100%', color: 'white' }}
                                >
                                    {card.description}
                                </Typography>
                            </Box>
                        </Link>
                    </Grid>
                )
                })}
            </Grid>
        </RegularSection>
    )
}

export default Index
